import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var SearchListItemWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  grid-template-rows: 1fr auto;\n  grid-template-areas:\n    'ListItemWrapper PriceTagWrapper'\n    'ButtonWrapper ButtonWrapper';\n\n  gap: ", "px;\n  align-items: center;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  padding: ", "px;\n\n  @media (min-width: ", "px) {\n    grid-template-columns: 2fr 1fr auto;\n    grid-template-rows: 1fr;\n    grid-auto-flow: row;\n    grid-template-areas: 'ListItemWrapper PriceTagWrapper ButtonWrapper';\n    gap: ", "px;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  grid-template-rows: 1fr auto;\n  grid-template-areas:\n    'ListItemWrapper PriceTagWrapper'\n    'ButtonWrapper ButtonWrapper';\n\n  gap: ", "px;\n  align-items: center;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  padding: ", "px;\n\n  @media (min-width: ", "px) {\n    grid-template-columns: 2fr 1fr auto;\n    grid-template-rows: 1fr;\n    grid-auto-flow: row;\n    grid-template-areas: 'ListItemWrapper PriceTagWrapper ButtonWrapper';\n    gap: ", "px;\n  }\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xs;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.white;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.light;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.sm;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.headerBreakpoint;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.sm2;
});
var ListItemWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  grid-area: ListItemWrapper;\n"], ["\n  grid-area: ListItemWrapper;\n"])));
styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  grid-area: PriceTagWrapper;\n  display: flex;\n  justify-content: flex-end;\n\n  @media (min-width: ", "px) {\n    justify-content: flex-end;\n  }\n"], ["\n  grid-area: PriceTagWrapper;\n  display: flex;\n  justify-content: flex-end;\n\n  @media (min-width: ", "px) {\n    justify-content: flex-end;\n  }\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.headerBreakpoint;
});
var ButtonWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  grid-area: ButtonWrapper;\n  display: flex;\n  align-items: center;\n  justify-self: end;\n  min-width: ", "px;\n\n  @media (min-width: ", "px) {\n    flex-direction: column;\n    gap: ", "px;\n    margin-top: -", "px;\n  }\n"], ["\n  grid-area: ButtonWrapper;\n  display: flex;\n  align-items: center;\n  justify-self: end;\n  min-width: ", "px;\n\n  @media (min-width: ", "px) {\n    flex-direction: column;\n    gap: ", "px;\n    margin-top: -", "px;\n  }\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.buttonWrapperMinWidth;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.headerBreakpoint;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxs;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.sm2;
});
var ToolTip = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  visibility: hidden;\n  position: absolute;\n  min-width: ", "px;\n  background-color: ", ";\n  color: ", ";\n  text-align: center;\n  padding: ", "px;\n  border-radius: ", "px;\n  z-index: 1;\n  opacity: 0;\n  transition: opacity 0.3s;\n  font-size: ", "px;\n\n  top: ", "%;\n  transform: translateY(-50%);\n  left: ", "px;\n\n  ::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    right: 100%;\n    margin-top: ", "px;\n    border-width: ", "px;\n    border-style: solid;\n    border-color: transparent\n      ", " transparent\n      transparent;\n  }\n"], ["\n  visibility: hidden;\n  position: absolute;\n  min-width: ", "px;\n  background-color: ", ";\n  color: ", ";\n  text-align: center;\n  padding: ", "px;\n  border-radius: ", "px;\n  z-index: 1;\n  opacity: 0;\n  transition: opacity 0.3s;\n  font-size: ", "px;\n\n  top: ", "%;\n  transform: translateY(-50%);\n  left: ", "px;\n\n  ::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    right: 100%;\n    margin-top: ", "px;\n    border-width: ", "px;\n    border-style: solid;\n    border-color: transparent\n      ", " transparent\n      transparent;\n  }\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.tooltipMinWidth;
}, function (_a) {
  var _b;

  var backgroundColor = _a.backgroundColor,
      theme = _a.theme;
  return backgroundColor || ((_b = theme.constants) === null || _b === void 0 ? void 0 : _b.toolTipBackground);
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.white;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxs;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xs;
}, function (_a) {
  var _b, _c;

  var theme = _a.theme;
  return (_c = (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.size) === null || _c === void 0 ? void 0 : _c.s1;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.iconToolTipTop;
}, function (_a) {
  var left = _a.left;
  return left;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.toolTipArrowMarginTop;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.toolTipArrowBorderWidth;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.toolTipBackground;
});
var MarkingWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: ", "px;\n  justify-self: flex-start;\n  align-self: start;\n  position: relative;\n  grid-column: 1;\n  grid-row: 1;\n  z-index: 5;\n  grid-gap: ", "px;\n  grid-auto-flow: column;\n"], ["\n  display: grid;\n  grid-template-columns: ", "px;\n  justify-self: flex-start;\n  align-self: start;\n  position: relative;\n  grid-column: 1;\n  grid-row: 1;\n  z-index: 5;\n  grid-gap: ", "px;\n  grid-auto-flow: column;\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.searchListItemGridTemplateColumns;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.MarkingWrapperGridGap;
});
var Marking = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  &:hover ", " {\n    visibility: visible;\n    opacity: 0.9;\n  }\n"], ["\n  &:hover ", " {\n    visibility: visible;\n    opacity: 0.9;\n  }\n"])), ToolTip);
var MaxWrapper = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", "px;\n  opacity: ", ";\n  white-space: nowrap;\n"], ["\n  color: ", ";\n  font-size: ", "px;\n  opacity: ", ";\n  white-space: nowrap;\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.alertRed;
}, function (_a) {
  var _b, _c;

  var theme = _a.theme;
  return (_c = (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.size) === null || _c === void 0 ? void 0 : _c.xs;
}, function (_a) {
  var showMax = _a.showMax;
  return showMax ? 1 : 0;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
export { ButtonWrapper, ListItemWrapper, Marking, MarkingWrapper, MaxWrapper, SearchListItemWrapper, ToolTip };